import { render, staticRenderFns } from "./automated-check-in.vue?vue&type=template&id=67681e65&scoped=true"
import script from "./automated-check-in.vue?vue&type=script&lang=js"
export * from "./automated-check-in.vue?vue&type=script&lang=js"
import style0 from "./automated-check-in.vue?vue&type=style&index=0&id=67681e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67681e65",
  null
  
)

export default component.exports